module.exports = __webpack_public_path__ + "img/idi-1.8bb4bdb3.jpg";